const image1 = 'https://res.cloudinary.com/artieve-test/image/upload/v1762373920/hillcloudsposter_xtlqw6.svg'
const image2 = 'https://res.cloudinary.com/artieve-test/image/upload/v1762373921/owlinmountains_olv4o3.svg'
const image3 = 'https://res.cloudinary.com/artieve-test/image/upload/v1762373920/gradlakeposter_bgwoyh.svg'
const image4 = 'https://res.cloudinary.com/artieve-test/image/upload/v1762373922/planthillsposter_a5hnxk.svg'
const image5 = 'https://res.cloudinary.com/artieve-test/image/upload/v1762373920/moontreesposter_zlylof.svg'

const homeData = [
    {
        image: image1,
        subhead: "Grief, when it comes, is nothing like we expect it to be.",
        content: [
            "Joan Didion",
            "Grief is the deep sadness we feel when we lose someone or something important to us.",
            "It's like a heavy heartache that can come and go, and it's natural to feel this way when we miss someone or something we care about."
        ]
    },
    {
        image: image2,
        subhead: "Artieve is here to support your feelings and help you grow.",
        content: ["Sometimes there are no words to describe how you feel, especially when you are grieving the loss of someone or something important to you."]
    },
    {
        image: image3,
        subhead: "Artieve is here to support your feelings and help you grow.",
        content: ['After a short wellness check-in, you will receive an art therapy prompt to help you begin. You have a choice of using the art materials or using your own detailed word descriptors to help you create the image you have in mind. There is no such thing as "good", "wrong," or "right" in art therapy. There are no mistakes.']
    },
    {
        image: image4,
        subhead: "Create art to discover the world inside you.",
        content: ["Use the canvas, colors and art tools to create the image you have in mind."]
    },
    {
        image: image5,
        subhead: "Create artworks using AI",
        content: ["You can choose to use your words to create the image you have in mind. The better you describe your image the more detailed the outcome will be."]
    },
]

export default homeData